import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { Paper } from '@material-ui/core';
import DevisService from '../../../services/devis/DevisService';
import DevisParams from './DevisParams';

import './DevisParamsContent.css';

const styles = theme => ({
    root: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    formControl: {
        margin: theme.spacing.unit,
        minWidth: 120,
    },
    selectEmpty: {
        marginTop: theme.spacing.unit * 2,
    },
});

class DevisContent extends Component {

    devisService = new DevisService();

    constructor(props) {
        super(props);
        this.state = {
        }
    }

    render() {
        return (
            <div id="devisContent" className="dataList">                
                <DevisParams classes={this.props.classes} categories={this.devisService.getCategories()} params={this.props.params} />                
            </div>
        );
    }
}

DevisContent.propTypes = {
    params: PropTypes.object.isRequired,
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(DevisContent);


// WEBPACK FOOTER //
// ./src/components/content/devis/DevisParamsContent.js